// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","256":"component---src-templates-blog-tsx","276":"component---src-templates-index-tsx"}[chunkId] + "-" + {"223":"4fe1ff43c4267cd19183","256":"6a5dbd7c6d57d02b13fc","276":"1dc445141ef89212cb9b"}[chunkId] + ".js";
};